export const ADD_FAVORITE = 'ADD_FAVORITE'
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'
export const FETCH_POKEMONS = 'FETCH_POKEMONS'
export const SET_FETCH_POKEMON_LOADING = 'SET_FETCH_POKEMON_LOADING'
